/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AfterOrderBannerLinkGet200Response } from '../model';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { LandingContents } from '../model';
// @ts-ignore
import { NewLandingContents } from '../model';
/**
 * LandingContentsApiLandingContentsCountGet - axios parameter creator
 * Retrieve the numver of landing-contents documents
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/landing-contents/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsDetailsGet - axios parameter creator
 * 
 * @summary 
 * @param {string} [url] url
 * @param {string} [parent] parent
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsDetailsGetAxiosParamCreator (url?: string, parent?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/landing-contents/details`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (url !== undefined) {
        localVarQueryParameter['url'] = url;
    }

    if (parent !== undefined) {
        localVarQueryParameter['parent'] = parent;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsGet - axios parameter creator
 * Find all the landing-contents\'s records
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/landing-contents`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsIdDelete - axios parameter creator
 * Delete a single landing-contents record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('landingContentsIdDelete', 'id', id)
    const localVarPath = `/landing-contents/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsIdGet - axios parameter creator
 * Find one landing-contents record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('landingContentsIdGet', 'id', id)
    const localVarPath = `/landing-contents/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsIdPut - axios parameter creator
 * Update a single landing-contents record
 * @summary 
 * @param {string} id 
 * @param {NewLandingContents} newLandingContents 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsIdPutAxiosParamCreator (id: string, newLandingContents: NewLandingContents, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('landingContentsIdPut', 'id', id)
    // verify required parameter 'newLandingContents' is not null or undefined
    assertParamExists('landingContentsIdPut', 'newLandingContents', newLandingContents)
    const localVarPath = `/landing-contents/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newLandingContents, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsPost - axios parameter creator
 * Create a new landing-contents record
 * @summary 
 * @param {NewLandingContents} newLandingContents 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsPostAxiosParamCreator (newLandingContents: NewLandingContents, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newLandingContents' is not null or undefined
    assertParamExists('landingContentsPost', 'newLandingContents', newLandingContents)
    const localVarPath = `/landing-contents`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newLandingContents, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LandingContentsApiLandingContentsSitemapGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LandingContentsApiLandingContentsSitemapGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/landing-contents/sitemap`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for landingContentsDetailsGet operation in LandingContentsApi.
 * @export
 * @interface LandingContentsApiLandingContentsDetailsGetRequest
 */
export interface LandingContentsApiLandingContentsDetailsGetRequest {
    /**
     * url
     * @type {string}
     * @memberof LandingContentsApiLandingContentsDetailsGet
     */
    readonly url?: string

    /**
     * parent
     * @type {string}
     * @memberof LandingContentsApiLandingContentsDetailsGet
     */
    readonly parent?: string
}

/**
 * Request parameters for landingContentsGet operation in LandingContentsApi.
 * @export
 * @interface LandingContentsApiLandingContentsGetRequest
 */
export interface LandingContentsApiLandingContentsGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof LandingContentsApiLandingContentsGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof LandingContentsApiLandingContentsGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof LandingContentsApiLandingContentsGet
     */
    readonly start?: number
}

/**
 * Request parameters for landingContentsIdDelete operation in LandingContentsApi.
 * @export
 * @interface LandingContentsApiLandingContentsIdDeleteRequest
 */
export interface LandingContentsApiLandingContentsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingContentsApiLandingContentsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for landingContentsIdGet operation in LandingContentsApi.
 * @export
 * @interface LandingContentsApiLandingContentsIdGetRequest
 */
export interface LandingContentsApiLandingContentsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingContentsApiLandingContentsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for landingContentsIdPut operation in LandingContentsApi.
 * @export
 * @interface LandingContentsApiLandingContentsIdPutRequest
 */
export interface LandingContentsApiLandingContentsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingContentsApiLandingContentsIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewLandingContents}
     * @memberof LandingContentsApiLandingContentsIdPut
     */
    readonly newLandingContents: NewLandingContents
}

/**
 * Request parameters for landingContentsPost operation in LandingContentsApi.
 * @export
 * @interface LandingContentsApiLandingContentsPostRequest
 */
export interface LandingContentsApiLandingContentsPostRequest {
    /**
     * 
     * @type {NewLandingContents}
     * @memberof LandingContentsApiLandingContentsPost
     */
    readonly newLandingContents: NewLandingContents
}

/**
* Retrieve the numver of landing-contents documents
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {LandingContentsApiLandingContentsDetailsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsDetailsGet(requestParameters: LandingContentsApiLandingContentsDetailsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsDetailsGetAxiosParamCreator(requestParameters.url, requestParameters.parent, options, configuration);
    const request: () => AxiosPromise<LandingContents> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Find all the landing-contents\'s records
* @summary 
* @param {LandingContentsApiLandingContentsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsGet(requestParameters: LandingContentsApiLandingContentsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<Array<LandingContents>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a single landing-contents record
* @summary 
* @param {LandingContentsApiLandingContentsIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsIdDelete(requestParameters: LandingContentsApiLandingContentsIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Find one landing-contents record
* @summary 
* @param {LandingContentsApiLandingContentsIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsIdGet(requestParameters: LandingContentsApiLandingContentsIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<LandingContents> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a single landing-contents record
* @summary 
* @param {LandingContentsApiLandingContentsIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsIdPut(requestParameters: LandingContentsApiLandingContentsIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsIdPutAxiosParamCreator(requestParameters.id, requestParameters.newLandingContents, options, configuration);
    const request: () => AxiosPromise<LandingContents> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new landing-contents record
* @summary 
* @param {LandingContentsApiLandingContentsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsPost(requestParameters: LandingContentsApiLandingContentsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsPostAxiosParamCreator(requestParameters.newLandingContents, options, configuration);
    const request: () => AxiosPromise<LandingContents> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LandingContentsApiLandingContentsSitemapGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LandingContentsApiLandingContentsSitemapGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AfterOrderBannerLinkGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
